// MDI tab system — REMOVED.
//
// The multi-document-interface tab strip (TabStrip + per-tab MemoryRouter +
// cross-tab persistence) used to live here. It was ripped out in favor of
// plain react-router navigation with a breadcrumb trail (see
// `packages/ds/navigation/navTrail.tsx`).
//
// This file is kept as an inert compatibility shim: every export still
// resolves, but the hooks return safe defaults and the provider is a
// passthrough. Consumers (legacy `useTabLabel`, `useTabActions`, etc.) can
// be migrated to drop the calls entirely at their leisure — leaving the
// stubs in place keeps the diff for the rip-out manageable.

import React from "react";

// ─── Public types — kept stable so importers still resolve ────────────────

export type TabId = string;

export interface Tab {
  id: TabId;
  url: string;
  label: string | undefined;
  icon?: React.ReactNode;
  pinned: boolean;
  lastActiveAt: number;
  createdAt: number;
}

export interface OpenOptions {
  newTab?: boolean;
}

export interface TabsActionsValue {
  open: (url: string, opts?: OpenOptions) => void;
  close: (id: TabId) => void;
  closeMany: (ids: TabId[]) => void;
  activate: (id: TabId) => void;
  togglePin: (id: TabId) => void;
  setLabel: (
    id: TabId,
    label: string | undefined,
    icon?: React.ReactNode,
  ) => void;
  syncUrl: (id: TabId, url: string) => void;
  outerNavigateRef: React.MutableRefObject<((url: string) => void) | null>;
  activeIdRef: React.MutableRefObject<TabId | null>;
  readonly mounted: true;
}

export interface TabsStateValue {
  tabs: Tab[];
  activeId: TabId | null;
  activeTab: Tab | null;
}

export type TabsContextValue = TabsActionsValue & TabsStateValue;

// ─── Public API — inert passthrough components ────────────────────────────

export function TabScope({
  children,
}: {
  id: TabId;
  children: React.ReactNode;
}) {
  // No-op wrapper — kept so TabbableRoutes / legacy callers compile.
  return <>{children}</>;
}

export function TabsProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
